class iframeResizerScroller {

    initializeScrollTop() {
        window.iFrameResizer = {
            onReady: function () {
                if ('parentIFrame' in window) { parentIFrame.scrollTo(0,0); }
            }
        }
    }

}
export default iframeResizerScroller
